// src/components/layout/Sidebar.jsx
import React, { useState } from 'react'; // Import useState
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../images/Logo.png'

const Sidebar = ({ isOpen, onClose, onExpand, onCollapse }) => { // Added onExpand, onCollapse props
  const { logout } = useAuth();
  const [isHovered, setIsHovered] = useState(false); // New state for hover

  // Determine the active state for the sidebar's width.
  // It's open if the prop is true OR if it's not open (shrunk) but is being hovered.
  const isSidebarExpanded = isOpen || (isHovered && !isOpen);

  const navLinks = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: (props) => (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
      )
    },
    {
      name: 'Inventories',
      path: '/products',
      icon: (props) => (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      )
    },
    {
      name: 'ecoMatch Hub',
      path: '/match',
      icon: (props) => (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" >
          <path fill="#000000" d="M9.116 18.38q-1.641-.741-2.713-2.165T5.075 13h1.006q.225 1.364 1.023 2.483t2.011 1.794zM12.712 21q-.51 0-.861-.351t-.351-.86v-5.193q0-.51.351-.86t.86-.351h1.7q.299 0 .579.146t.44.413l.57.864h3.789q.509 0 .86.35q.351.352.351.861v3.77q0 .509-.351.86t-.86.351zm-8.5-10.385q-.51 0-.861-.35T3 9.403V4.212q0-.51.351-.861T4.211 3h1.7q.299 0 .579.146t.44.414l.57.863h3.789q.509 0 .86.351t.351.86v3.77q0 .51-.351.86t-.86.352zM18 12q0-1.664-.829-3.07q-.829-1.407-2.286-2.188V5.658q1.91.81 3.012 2.543T19 12zm-5.173 8h6.846q.135 0 .23-.096q.097-.096.097-.231v-3.538q0-.135-.086-.231q-.087-.096-.241-.096h-4.21l-.807-1.212q-.058-.096-.164-.154t-.22-.058h-1.445q-.135 0-.23.097q-.097.096-.097.23v4.962q0 .135.096.23q.096.097.231.097m-8.5-10.385h6.846q.135 0 .23-.096q.097-.096.097-.23V5.75q0-.134-.086-.23t-.241-.097h-4.21l-.807-1.211q-.058-.096-.164-.154T5.772 4H4.326q-.135 0-.23.096Q4 4.192 4 4.327v4.962q0 .134.096.23q.096.097.231.097M12.5 20v-5.615zM4 9.616V4z" />
        </svg>
      )
    },
    {
      name: 'Settings',
      path: '/settings',
      icon: (props) => (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
  ];

  return (
    <aside
      // Add onMouseEnter and onMouseLeave handlers
      onMouseEnter={() => !isOpen && setIsHovered(true)}
      onMouseLeave={() => isHovered && setIsHovered(false)}

      className={`fixed top-0 left-0 h-full bg-white border-r border-gray-200 z-30 transition-all duration-300 ease-in-out
        // Use isSidebarExpanded to determine the width and visibility
        ${isSidebarExpanded ? 'w-1/5' : 'w-20 -translate-x-full lg:translate-x-0'} 
        pt-16 lg:pt-0`}
    >
      <div className="flex flex-col h-full pb-4">
        <nav className="flex-1 mt-20">
          <ul className="space-y-1 px-2">
            {navLinks.map((link) => (
              <li key={link.name}>
                <NavLink
                  to={link.path}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center p-3 rounded-lg transition-colors duration-200 text-sm
      ${isActive ? 'bg-primary text-white' : 'text-dark hover:bg-primary-light'}
      ${isSidebarExpanded ? 'justify-start' : 'justify-center'}`
                  }
                >
                  <link.icon className={`h-5 w-5 ${isSidebarExpanded ? 'mr-3' : 'mx-auto'}`} />
                  <span className={`${isSidebarExpanded ? 'block' : 'hidden'}`}>
                    {link.name}
                  </span>
                </NavLink>

              </li>
            ))}
          </ul>
        </nav>

        {/* Logout Button */}
        <div className="px-2 pb-4">
          <button
            onClick={() => {
              logout();
              onClose();
            }}
            className={`flex items-center p-3 rounded-lg transition-colors duration-200 w-full text-[13px]
      ${isSidebarExpanded ? 'justify-start' : 'justify-center'}
      text-dark hover:hover:bg-primary-light hover:text-dark`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${isSidebarExpanded ? 'mr-3' : 'mx-auto'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span className={`${isSidebarExpanded ? 'block' : 'hidden'}`}>
              Logout
            </span>
          </button>

        </div>
        <div className="flex items-center justify-center">
          <img src={logo} alt="Cropser logo" className="h-[72px] w-28" />
        </div>

      </div>
    </aside>
  );
};

export default Sidebar;